import { render, staticRenderFns } from "./trawl-pack-with-text.vue?vue&type=template&id=04e9d7a0"
import script from "./trawl-pack-with-text.vue?vue&type=script&lang=js"
export * from "./trawl-pack-with-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports